import type { I18nFn } from '#/i18n/types/I18nFn';
import { ApiOrgType } from '#/modules/listing/orgs/api/types/ApiOrgType';

export const ORG_TYPES = (i18n: I18nFn) =>
  ({
    [ApiOrgType.NONPROFIT]: i18n('Nonprofit'),
    [ApiOrgType.GOVERNMENT]: i18n('Government'),
    [ApiOrgType.CORPORATION]: i18n('Business'),
    [ApiOrgType.CONSULTANT]: i18n('Consultant'),
    [ApiOrgType.RECRUITER]: i18n('Recruiter'),
    [ApiOrgType.COMMUNITY]: i18n('Community Group'),
    [ApiOrgType.GROUP]: i18n('Group'),
  }) satisfies Record<ApiOrgType, string>;

const CREATABLE_ORG_TYPES = [
  ApiOrgType.NONPROFIT,
  ApiOrgType.GOVERNMENT,
  ApiOrgType.CORPORATION,
  ApiOrgType.CONSULTANT,
  ApiOrgType.RECRUITER,
  ApiOrgType.COMMUNITY,
];

const SEARCHABLE_ORG_TYPES = [
  ApiOrgType.NONPROFIT,
  ApiOrgType.GOVERNMENT,
  ApiOrgType.CORPORATION,
  ApiOrgType.CONSULTANT,
  ApiOrgType.RECRUITER,
  ApiOrgType.COMMUNITY,
];

export const ORG_TYPE_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(ORG_TYPES(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));

export const ORG_TYPE_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(ORG_TYPES(i18n)).map(([key, value]) => ({
    value: key,
    label: value,
  }));

export const CREATABLE_ORG_TYPE_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  CREATABLE_ORG_TYPES.map((orgType) => ({
    value: orgType,
    label: ORG_TYPES(i18n)[orgType],
  }));

export const SEARCHABLE_ORG_TYPES_MAP = (i18n: I18nFn) =>
  Object.fromEntries(
    SEARCHABLE_ORG_TYPES.map((orgType) => [orgType, ORG_TYPES(i18n)[orgType]]),
  );

export const SEARCH_ORG_TYPE_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  SEARCHABLE_ORG_TYPES.map((orgType) => ({
    name: orgType,
    label: ORG_TYPES(i18n)[orgType],
  }));
